const Dynamics = theme => {
  return {
    background: {
      backgroundImage:
        'linear-gradient(to right top, #3e2772, #4f3291, #613eb1, #734ad3, #8656f5)',
    },
    foreground: {
      color: 'rgba(255,255,255,.7)'
    },
    from: '#3e2772',
    to: '#8656f5',
  }
}

export default Dynamics



// WEBPACK FOOTER //
// ./src/styles/mixins/gradients/dynamics.js